import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmMessageModalContext } from '../confirm-message-modal/confirm-message-modal.component';
import { IFirebaseAddress} from '@ztarmobile/zwp-service-backend';
import { AddressLookupComponent } from '@widgets/address-lookup/address-lookup.component';

export type AddressModalDataType = {
  customClass?: string,
  title?: string,
  displayedAddress?: IFirebaseAddress
}

@Component({
  selector: 'app-add-address-modal',
  templateUrl: './add-address-modal.component.html',
  styleUrl: './add-address-modal.component.scss'
})
export class AddAddressModalComponent {
  @ViewChild('addressLookup') addressLookup: AddressLookupComponent;

  public isValidAddress = true;
  public touchShippimgForm = true;
  public resetAddressForm = true;
  public address: IFirebaseAddress;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AddressModalDataType,
    public dialog: MatDialogRef<ConfirmMessageModalContext>,
  ) { }

  public addressLookUpChanged(address: IFirebaseAddress, isEdit?: boolean): void {
    this.address = address;
    if (this.data.displayedAddress) {
      this.address.id = this.data.displayedAddress.id;
    }
  }

  public save() {
    this.addressLookup.addressFieldsForm.markAllAsTouched();

    if (this.addressLookup.addressFieldsForm.invalid) {
      return;
    }

    this.closeDialog(this.address);
  }

  public setValidAddress(isValid: boolean, isEdit?: boolean): void {
    if (!!isEdit) {
      this.isValidAddress = !!this.address.address1 && !!this.address.city && !!this.address.postalCode && !!this.address.state;
    } else {
      this.isValidAddress = !!this.address && !!this.address.address1 && !!this.address.city && !!this.address.postalCode && !!this.address.state;
    }
  }

  beforeClose(): boolean {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
    return false;
  }

  closeDialog(res?): void {
    this.beforeClose();
    this.dialog.close(res);
  }
}
